import { RouteObject } from '@leagueplatform/routing';
import {
  APP_MANAGED_ROUTES,
  CONTENT_ROUTES,
  GenericMasonryPageWrapper,
  LoadingSpinner,
  PageBlockerContainer,
} from '@highmark-web/highmark-common';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import {
  GenericMasonryPage,
  MASONRY_ROUTES,
  MasonryPDF,
} from '@leagueplatform/masonry';
import {
  AboutMeRoutes,
  AchievementsRoutes,
  CareCollectionsRoutes,
  CareDiscoveryRoutes,
  ClaimsRoutes,
  HealthJourneyRoutes,
  HealthProfileRoutes,
  LiveChatPage,
  MessagingRoutes,
} from 'components/lazy-routes.component';
import { AppBenefitsRoutes } from 'pages/benefits/benefits.routes';

const healthJourneyPaths = [
  `${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/*`,
  `${getModulePath(LEAGUE_MODULE_NAMES.healthPrograms)}/*`,
  `${getModulePath(LEAGUE_MODULE_NAMES.healthProgress)}/*`,
  `${getModulePath(LEAGUE_MODULE_NAMES.healthJourneyHistory)}/*`,
];

export const LeagueSDKRoutes: RouteObject[] = [
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.aboutMe)}/*`,
    element: <AboutMeRoutes />,
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.rewardsAchievements)}/*`,
    element: <AchievementsRoutes />,
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.benefits)}/*`,
    element: <AppBenefitsRoutes />,
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.careCollections)}/*`,
    element: (
      <PageBlockerContainer contentRoute={CONTENT_ROUTES.CARE}>
        <CareCollectionsRoutes />
      </PageBlockerContainer>
    ),
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.careDiscovery)}/*`,
    element: (
      <PageBlockerContainer contentRoute={CONTENT_ROUTES.CARE}>
        <CareDiscoveryRoutes />
      </PageBlockerContainer>
    ),
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.claims)}/*`,
    element: <ClaimsRoutes />,
  },
  {
    path: APP_MANAGED_ROUTES.GENERIC_MASONRY_PAGE,
    element: (
      <GenericMasonryPage pageWrapperComponent={GenericMasonryPageWrapper} />
    ),
  },
  ...healthJourneyPaths.map((path) => ({
    path,
    element: <HealthJourneyRoutes />,
  })),
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.healthProfile)}/*`,
    element: <HealthProfileRoutes />,
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.liveChat)}/*`,
    element: <LiveChatPage />,
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.messaging)}/*`,
    element: <MessagingRoutes />,
  },
  {
    path: `${MASONRY_ROUTES.PDF_GENERATION}/*`,
    element: <MasonryPDF loader={<LoadingSpinner />} />,
  },
];
